<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">部门名称</div>
          <div class="field">
            <el-input v-model.trim="query.dptname"  clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">所在区域</div>
          <div class="field">
            <!-- <el-input v-model.trim="query.dptarename"  clearable></el-input> -->
            <el-select v-model="query.dptregionid" :clearable="true" placeholder="请选择">
                <el-option v-for="item in dptareaList" :key="item.dptareaid" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick"
             @cellDblClick="viewProject" @pagechange="pagechange"
        :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  export default {
    name: 'dptIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        btn:{},
        dptareaList:[],
        dptobj:{},
        list:[],
        cols:[
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'dptname', fieldtype: 'C', title: '部门名称',calculExpr:''},
          { field: 'dptsign', fieldtype: 'C', title: '部门标识',calculExpr:''},
          { field: 'dptcode', fieldtype: 'C', title: '区域简称',calculExpr:''},
          { field: 'dptareaname', title: '所在区域', span: 8, folding: true },
          // { field: 'dptremark', fieldtype: 'C',title: '备注',calculExpr:'',editRender: { name: 'input'}}
        ],
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.adddpt())
      this.$on('CHG', () => this.chgdpt())
      this.$on('DEL', () => this.deldpt())
    },
    activated() {
      this.getPageList()
      this.getDptareaList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.dpt = row
        this.$emit(code,row)
      },
      async cellClick (row) {
        this.dpt = row.row
      },
      btnmenuclick(btn){
        this.btn = btn
        this.btnClone = _.cloneDeep(btn)
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async viewProject(row) {
        this.dptobj = row.row
        this.$router.push({name: 'dptfrom', params: {dpt:this.dptobj, type: 2}})
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getDptareaList(){
          this.loading = true
          let res = await request({
              method: 'get',
              url: '/xtgl/dpt/getDptareaList',
              params: {cosid:this.$store.getters.loginUser.cosid}
          })
          this.dptareaList = res
          this.loading = false
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/dpt/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async adddpt(){
        let form = {}
        this.$router.push({name: 'dptfrom', params: {dpt:form, type: 1}})
      },
      async chgdpt(){
        this.$router.push({name: 'dptfrom', params: {dpt:this.dpt, type: 1}})

      },
      async deldpt () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/dpt/delDpt',
            method: "post",
            data: this.dpt
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
    }
  }
</script>
<style lang="scss">

</style>
